export const SET_REPORT_PASSWORD = '@report/SET_REPORT_PASSWORD';
export const CLEAR_REPORT_PASSWORDS = '@report/CLEAR_REPORT_PASSWORDS';
